export function randomRange(min: number, max: number) {
  return min + Math.random() * (max - min);
}
